import { Group, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { TitleCard } from '@/core/components';

import { Committee } from '../../model/CommitteeTypes';
import classes from './CommitteeCard.module.css';

export interface CommitteeCardProps {
  committee: Committee;
  to?: string;
  onClick?: () => void;
}

export function CommitteeCard({ committee, to, onClick }: CommitteeCardProps) {
  const { title, startYear, endYear, type } = committee;

  return (
    <Paper
      className={classes.card}
      onClick={onClick}
      component={Link}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="4px">
        <TitleCard title={title} />
        <Group gap="xs">
          <Text
            c="dimmed"
            size="sm"
          >
            {startYear} - {endYear ?? '?'}
          </Text>

          <Text
            c="dimmed"
            size="sm"
          >
            {type?.name}
          </Text>
        </Group>
      </Stack>
    </Paper>
  );
}
